import styled from 'styled-components';
import ConfidentialitySvg from '../../../assets/onboarding/newHome/confidentially.svg';

const ConfidentialityIcon = styled(ConfidentialitySvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '4.4rem'};
height: ${props => props.height || '4.4rem'};
display: flex;
`;

export default ConfidentialityIcon;
